// **********************************************************
// Main menu dropdown
// **********************************************************
attachEvent('.menu__item.has-megamenu .menu__link', 'click', (ev) => {
  ev.stopPropagation();

  const item = ev.target.closest('.menu__item');
  const isActive = item.classList.contains('is-open-megamenu');

  document
    .querySelectorAll('.menu__item.has-megamenu.is-open-megamenu')
    .forEach((el) => el.classList.remove('is-open-megamenu'));

  if (!isActive) item.classList.add('is-open-megamenu');
});

document.addEventListener('click', (ev) => {
  if (!ev.target.closest('.menu__item.has-megamenu')) {
    if (windowWidth() > breakpointMd) {
      document
        .querySelectorAll('.menu__item.has-megamenu.is-open-megamenu')
        .forEach((el) => el.classList.remove('is-open-megamenu'));
    }
  }
});

attachEvent('.megamenu__back', 'click', () => {
  document
    .querySelectorAll('.menu__item.has-megamenu.is-open-megamenu')
    .forEach((el) => el.classList.remove('is-open-megamenu'));
});
